export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "q1",
    q: "黑料入口导航站和普通分类页有什么区别？",
    a: "这里不替你二次加工内容，只做「推荐、合集、大全、汇总」四件事：把可用入口按类归好、标注更新时间和入口数量，剩下的挑看节奏完全交给你。点开就是一个入口，不合适就退回列表继续挑。",
  },
  {
    id: "q2",
    q: "入口列表是按什么顺序排的？",
    a: "默认按「更新新鲜度」排，最近有更新的排在前面；切换到热度视图则按近 24 小时的访问热度重排。两种排序都能在列表顶部一键切换，序号只代表当前视图下的位置。",
  },
  {
    id: "q3",
    q: "合集和大全是怎么整理的？",
    a: "合集偏向同一主题的横向汇总，一个大全下会挂多个入口；归档类合集会附带时间线说明，方便补课。每个合集都标了入口数量和最近更新时间，更新慢的会明显标出来，避免白点。",
  },
  {
    id: "q4",
    q: "入口打不开或者内容变了怎么办？",
    a: "列表里的入口会定期做一次可访问性校验，异常的会先打上标记再下架。如果你点到的入口和标注不符，可以在使用指南里按「反馈路径」记一下入口名，下次整理时会优先复查这一条。",
  },
  {
    id: "q5",
    q: "移动端看信息会不会太挤？",
    a: "移动端会把大图卡片流改成单列，短讯条改为可横向滑动，分类区收成两列网格。信息量保持不变，但每次只展示一屏能装下的部分，往下滑就行，不用来回缩放。",
  },
  {
    id: "q6",
    q: "多久整理一次？",
    a: "推荐位和热榜每天整理，合集与归档按周回看一次，冷门名单按需补充。页面顶部的速览条会滚动显示当天的整理记录，只看速览条也能知道今天动过什么。",
  },
];